export enum LanguageTypeEnum {
  /** English */
  en = 'en',
  /** Español */
  es = 'es',
  /** українська */
  uk = 'uk',
  /** हिंदी */
  hi = 'hi',
  /** 日本語 */
  jp = 'jp',
  /** Deutsch */
  de = 'de',
  /** русский */
  ru = 'ru',
  /** Português */
  pt = 'pt',
  /** 简体中文 */
  zh = 'zh',
  /** Français */
  fr = 'fr',
  /** 한국어 */
  ko = 'ko',
  /** Türkçe */
  tr = 'tr',
  /** Bahasa Indonesia */
  id = 'id',
  /** Tiếng Việt */
  vi = 'vi',
  /** Italiano */
  it = 'it',
}
